import { Marker } from 'react-map-gl';
import SportsScoreIcon from '@mui/icons-material/SportsScore';

type EndMarkerProps = {
  coordinates: [number, number] | undefined;
};

export default function EndMarker({
  coordinates
}: EndMarkerProps): JSX.Element | null {
  if (!coordinates) return null;

  const latitude = coordinates[1];
  const longitude = coordinates[0];

  return (
    <Marker latitude={latitude} longitude={longitude}>
      <SportsScoreIcon />
    </Marker>
  );
}
